export const plans = {
  trial: { name: "trial", maxActiveRequests: 1, trialNotifications: 10 },
  student: { name: "student", maxActiveRequests: 1 },
  basic: { name: "basic", maxActiveRequests: 3 },
  pro: { name: "pro", maxActiveRequests: 7 },
  flexible: { name: "flexible", maxActiveRequests: 7 }, // legacy
  unlimited: { name: "unlimited", maxActiveRequests: 7 }, // legacy
};

// Products & pricing (single source of truth)
// Used by both the app (display) and scripts/admin/setup_stripe.js (Stripe sync).
// Amounts in whole currency units (dollars/euros/pounds).
export const products = {
  basic: {
    stripeName: "Schnerp Basic",
    description:
      "Unlimited notifications, via Email/Text, up to 3 Active Requests, Checks every 1-5 minutes",
    monthly: { CAD: 15, USD: 15, AUD: 15, NZD: 15, EUR: 13, GBP: 10 },
    annual: { CAD: 99, USD: 99, AUD: 99, NZD: 99, EUR: 89, GBP: 69 },
  },
  pro: {
    stripeName: "Schnerp Priority",
    description:
      "Unlimited PRIORITY notifications, via Email/Text/WhatsApp/Push, up to 7 Active Requests, Priority checking (twice as often as other plans)",
    monthly: { CAD: 29, USD: 29, AUD: 29, NZD: 29, EUR: 25, GBP: 19 },
    annual: { CAD: 199, USD: 199, AUD: 199, NZD: 199, EUR: 169, GBP: 129 },
  },
};

export function getDisplayPrice(product, currency) {
  return products[product]?.monthly[currency] ?? products[product]?.monthly.CAD;
}

export function getCheckoutConfig(productName) {
  const configs = {
    basic: {
      priceId: process.env.STRIPE_BASIC_PRICE_ID,
      mode: "subscription",
    },
    pro: { priceId: process.env.STRIPE_PRO_PRICE_ID, mode: "subscription" },
  };
  const config = configs[productName];
  if (!config?.priceId)
    throw new Error(`No checkout config for: ${productName}`);
  return {
    mode: config.mode,
    line_items: [{ price: config.priceId, quantity: 1 }],
    allow_promotion_codes: true,
  };
}

export function getPortalConfig(planName) {
  if (planName === "flexible") {
    return process.env.STRIPE_FLEXIBLE_PORTAL_CONFIG_ID || undefined;
  }
  return undefined;
}

export function getPlanFromPrice(price) {
  const planName = price.metadata?.plan;
  if (!planName || !plans[planName]) {
    throw new Error(`Invalid plan '${planName}' for price '${price.id}'`);
  }
  return plans[planName];
}

export const COUNTRY_CURRENCY = {
  US: "USD",
  NZ: "NZD",
  AU: "AUD",
  GB: "GBP",
  DE: "EUR",
  FR: "EUR",
  IT: "EUR",
  ES: "EUR",
  NL: "EUR",
  IE: "EUR",
  AT: "EUR",
  BE: "EUR",
  FI: "EUR",
  PT: "EUR",
  GR: "EUR",
  LU: "EUR",
};
export const getCurrencyFromCountry = (cc) =>
  COUNTRY_CURRENCY[cc?.toUpperCase()] || "CAD";

// Country detection (CF-IPCountry header, with local override)
export function getCountryCode(request) {
  return (
    process.env.DEV_COUNTRY_OVERRIDE ||
    request.headers.get("CF-IPCountry") ||
    null
  );
}
